import React, { useState, useEffect } from "react";
import { db, whatsappLink } from "../../config/FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import "./FloatingNotification.css";

const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState({
    title: "",
    subtitle: "",
    ctaText: "",
    isActive: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "config", "notification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setNotification({
            title: data.title || "",
            subtitle: data.subtitle || "",
            ctaText: data.ctaText || "",
            isActive: data.isActive !== undefined ? data.isActive : true,
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeVisible = window.scrollY > 600 && notification.isActive;
      if (shouldBeVisible !== isVisible) {
        setIsVisible(shouldBeVisible);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isVisible, notification.isActive]);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("ctaDismissed", "true");
  };

  if (isDismissed || !notification.isActive) return null;

  return (
    <div
      className={`floating-notification-container ${
        isVisible ? "visible" : ""
      }`}
    >
      <div className="floating-notification">
        <button
          className="close-button"
          onClick={handleDismiss}
          aria-label="Close notification"
        >
          <IoMdClose size={16} color="#4a5568" />
        </button>

        <div className="notification-content">
          <span className="notification-subtitle">{notification.subtitle}</span>
          <span className="notification-title">{notification.title}</span>
        </div>

        <Link
          to={whatsappLink}
          className="cta-button"
          aria-label="Call to action"
        >
          {notification.ctaText}
          <FaLongArrowAltRight className="cta-icon" />
        </Link>
      </div>
    </div>
  );
};

export default FloatingNotification;
